import ContactForm from './Comp_ContactForm.js';
import React from 'react';

function Contact({ img }) {
  return (
    <section className="pb-contact" style={{ backgroundImage: `url(${img})` }}>
      <div className="pb-contact-inner">
        <div className="pb-glass pb-invitation">
          <div className="pb-label pb-label-dark">
            <span className="pb-label-num">03</span>
            <span className="pb-label-rule" />
            <span className="pb-label-text">Contact</span>
          </div>
          <h2 className="pb-invitation-title">Drop me a line.</h2>
          <p className="pb-invitation-lede">Tell me about your project. Or just say hi.</p>
          <span className="pb-copy-rule" />
          <p className="pb-invitation-body">
            Share what you’re making, where it’s stuck, and what you’d like it to become. A clear note is a great place to start.
          </p>
        </div>

        <div className="pb-glass pb-form-glass">
          <span className="pb-form-highlight" />
          <ContactForm />
        </div>
      </div>
    </section>
  );
}

export default Contact;
